export class DanePodstawoweDoOswiadczenia {
  nazwaKlienta: string;
  czyWlaczone: boolean;
}
